namespace Matrix.Workflow {
    export class DataQualityWorkflowInstanceColumns {
        static columnsKey = 'Workflow.DataQualityWorkflowInstance';
    }
}
